import React, { Component } from 'react'
import { Row, Col, DatePicker, Input, message, Card, Space, Skeleton, Select } from 'antd'
import './index.css'
import '../../../../assets/css/common.css'
import { SoundOutlined } from '@ant-design/icons'
import * as echarts from 'echarts'
import ReactEcharts from 'echarts-for-react'
import ukPerson from './per.png'
// import usPerson from './usper.png'
import facebookImg from './innet.png'
// import twitterImg from './twi.png'
import twitterImg from './twitter.png'
import 'echarts-wordcloud'
// import mockdata from '../data/mockdata.json'
// import focusData from '../data/yiyuan_focus.json'
import meetingImgData from '../data/meetingImg.json'
// import countryCloudWords from '../data/country_cloud.json'
// import WordCloud from 'react-wordcloud'
// import { useSize } from 'ahooks'
// import Column from 'antd/lib/table/Column'
import fetch from '../../../../utils/fetch'

class Tool extends Component {
    constructor(props) {
        super(props)
        this.state = {
            cloudOption: {},
            mapInstance: null,
            showMeeting: true,
            genderOption: {},
            partyOption: {},
            areaOption: {
            },
            leftWidth: null,
            leftHeight: null,
            title: 'us',
            defaultCountry: 'us',
            yiyuan: null,
            yihui: null,
            personImg: ukPerson,
            yiyuanName: '',
            yiyuanParty: '',
            yiyuanArea: '',
            yiyuanTwi: '',
            served: '',
            birthday: '',
            canyuyihui: '',
            yiyuanFace: '',
            yiyuanList: [],
            selMeetDate: '2023-09-22',
            link: 'https://www.congress.gov/117/crec/2021/11/09/167/196/CREC-2021-11-09.pdf',
            num: 133,
            meetingImg: '../meeting_img/us.jpg',
            speakerCount: 34,
            speechCount: 213,
            minorHeading: 22,
            visitCount: 709,
            meetingList: [
                { title: 'Poor, middle class have been betrayed, says Kharge as Congress holds key poll preparedness meet' },
                { title: 'LDF retains Thodupuzha municipal chairperson post after IUML-Congress spat' },
                { title: 'Pelosi says it\'s her life goal to ensure \'that man\' Trump never steps in the White House again' }],
            speakerName: '',
            speakerName: '',
            speakerContent: '',
            listenerFlag: false,
            memberCache: {}, // 缓存图谱用到的议员数据
            topicList: [], // 议会主题数据
            graphLoaded: false, // 标记图谱是否加载完成
            // 缓存 API 数据，避免搜索时重复请求
            cachedGraphData: null,
            cachedMeetingData: null,
            cachedMemberData: null
        }
        this.ciyun = React.createRef()
        this.tupu = React.createRef()
        this.gender = React.createRef()
        this.party = React.createRef()
        this.area = React.createRef()
    }

    getRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min
    }
    getRandomDate() {
        let yearStr = this.getRandomNumber(2021, 2024)
        let monthStr = this.getRandomNumber(1, 7)
        let dayStr = this.getRandomNumber(1, 20)
        return yearStr + '-' + monthStr + '-' + dayStr
    }
    getArrayItems(arr, num) {
        // 取出的数值项，保存在此数组
        let that = this
        //复制一个新数组
        let return_arr = []
        let copyArr = arr.slice(0)
        for (let i = 0; i < num; i++) {
            //获取一个随机下标,然后删除该元素
            let randomIndex = that.getRandomNumber(0, copyArr.length)
            return_arr.push(copyArr[randomIndex])
            copyArr.splice(randomIndex, 1)
        }
        return return_arr
    }
    checkName(map, name) {
        if (map[name] && map[name].length > 0) {
            return true
        } else {
            map[name] = name
        }
    }
    //当用户通过select选择国家之后,触发页面的更新
    loadMeetImg(country) {
        let src = '../meeting_img/coucil.png'
        if (meetingImgData[country]) {
            src = '../meeting_img/' + meetingImgData[country].meetingImgSrc
        }
        this.setState({
            meetingImg: src
        })
    }
    localStorageSetHandler = (e) => {
        this.setState({
            title: e.value
        })
        //根据国家下拉替换议会图片
        this.drawGraphData(e.value)
        this.loadMeetImg(e.value)
        // this.drawRader(this.state.title, "1")
        this.drawWordCloud(e.value)
    };
    drawWordCloud = (key, meetingId) => {
        let that = this

        let url = '/graph/wc/search?country=' + key;
        if (meetingId) {
            // 修正：将参数名从 meetingid 改为 meeting_id，以匹配后端接口预期
            url += '&meeting_id=' + encodeURIComponent(meetingId);
        }

        fetch({
            url: url,
            method: "get",
        }).then(res => {

            function truncateText(text, maxLength) {
                return text.length > maxLength ? text.substring(0, maxLength - 1) + '…' : text;
            }
            // 兼容直接返回数组或嵌套在data中
            let words = (Array.isArray(res.data) ? res.data : res.data.data) || []
            const maxLength = 20; // 截断后的最大长度
            words = words.map(word => ({ ...word, name: truncateText(word.name || '', maxLength) }));
            const option = {
                backgroundColor: '#fff',
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.percentage:.1f}</b>',
                },
                series: [
                    {
                        type: 'wordCloud',
                        gridSize: 6,
                        // Text size range which the value in data will be mapped to.
                        // Default to have minimum 12px and maximum 60px size.
                        sizeRange: [10, 35],
                        top: 15,
                        // width: '98%',
                        // Text rotation range and step in degree. Text will be rotated randomly in range [-90,90] by rotationStep 45
                        // rotationRange: [-45, 0, 45, 90],  // 词语呈现的角度，翻转的角度
                        rotationRange: [0, 0, 0, 0], // 词语呈现的角度，翻转的角度
                        // maskImage: maskImage, // 呈现形状图片， 可选
                        textStyle: {
                            color: function () {
                                return (
                                    'rgb(' +
                                    Math.round(Math.random() * 255) +
                                    ', ' +
                                    Math.round(Math.random() * 255) +
                                    ', ' +
                                    Math.round(Math.random() * 255) +
                                    ')'
                                )
                            },
                        },
                        // Folllowing left/top/width/height/right/bottom are used for positioning the word cloud
                        // Default to be put in the center and has 75% x 80% size.
                        data: words,
                    },
                ],
            }
            // 使用对象展开运算符创建新对象，确保 React 检测到状态变化
            that.setState({
                cloudOption: { ...option, timestamp: Date.now() } // 添加时间戳强制更新
            })
        })
    }

    getTopics = (meetingId) => {
        // Fetch topics for the specific meeting
        // URL needs encoding if meetingId contains special chars, but the sample shows raw usage.
        // Sample ID: aHR0cHM6Ly93d3cuY29uZ3Jlc3MuZ292LzExOS9jcmVjLzIwMjUvMDkvMDQvMTcxLzE0NS9DUkVDLTIwMjUtMDktMDQucGRm_h
        // It looks like base64 + suffix. 
        // Using encodeURIComponent just in case.
        fetch({
            url: `/graph/topics/search?country=${this.state.defaultCountry}&meeting_id=${encodeURIComponent(meetingId)}`,
            method: 'get'
        }).then(res => {
            const data = res.data || {};
            const list = Array.isArray(data) ? data : (data.data || []);
            this.setState({
                topicList: list
            });
        }).catch(e => {
            console.error("Failed to fetch topics:", e);
            this.setState({ topicList: [] });
        });
    }



    updateMemberNames = async (memberIds, nodesDataSet, country) => {
        const ids = Array.from(memberIds);
        const batchSize = 10; // Limit concurrent requests to avoid blocking

        for (let i = 0; i < ids.length; i += batchSize) {
            const chunk = ids.slice(i, i + batchSize);
            const promises = chunk.map(id =>
                fetch({
                    url: `/graph/member/info?country=${country}&id=${id}`,
                    method: 'get'
                }).then(res => {
                    const data = res.data || {};
                    const name = data.name;
                    if (name) {
                        try {
                            nodesDataSet.update({ id: id, label: name });
                        } catch (e) {
                            // ignore update errors
                        }
                    }
                }).catch(e => {
                    console.warn(`Failed to fetch name for member ${id}`, e);
                })
            );
            await Promise.all(promises);
        }
    }

    // overrideMeetingIds: Set<string> - 如果提供，仅渲染这些会议
    // forceMemberId: string - 如果提供，强制包含该议员（忽略数量限制）
    async drawGraphData(key, overrideMeetingIds = null, forceMemberId = null) {
        const vis = require('vis-network/dist/vis-network')
        try {
            let graphRes, meetingRes, memberRes;

            // 检查是否有缓存数据（同一个 country）
            if (this.state.cachedGraphData && this.state.cachedMeetingData && this.state.cachedMemberData && this.cachedCountry === key) {
                // 使用缓存数据
                console.log('Using cached data for search/filter');
                graphRes = this.state.cachedGraphData;
                meetingRes = this.state.cachedMeetingData;
                memberRes = this.state.cachedMemberData;
            } else {
                // 首次加载或切换国家，需要请求数据
                console.log('Fetching fresh data from API');
                [graphRes, meetingRes, memberRes] = await Promise.all([
                    fetch({
                        url: '/graph/graph/data?country=' + key,
                        method: "get",
                    }).catch(e => {
                        console.error("Graph data fetch failed:", e);
                        return { data: {} };
                    }),
                    fetch({
                        url: '/graph/meeting/search?country=' + key,
                        method: "get",
                    }).catch(e => {
                        console.error("Meeting search fetch failed:", e);
                        return { data: [] };
                    }),
                    fetch({
                        url: '/graph/member/info?country=' + key,
                        method: "get",
                    }).catch(e => {
                        console.error("Member info fetch failed:", e);
                        return { data: [] };
                    })
                ]);

                // 缓存数据
                this.cachedCountry = key;
                this.setState({
                    cachedGraphData: graphRes,
                    cachedMeetingData: meetingRes,
                    cachedMemberData: memberRes
                });
            }

            console.log('Graph Res:', graphRes);
            console.log('Meeting Res:', meetingRes);
            console.log('Member Res:', memberRes);

            let meetingList = (Array.isArray(meetingRes.data) ? meetingRes.data : meetingRes.data.data) || []
            if (meetingRes.data && meetingRes.data.data) {
                meetingList = meetingRes.data.data;
            }

            meetingList.sort((a, b) => new Date(b.date) - new Date(a.date));

            // Select top 50 recent meetings
            const recentMeetings = meetingList.slice(0, 50);
            const defaultMeetingIds = new Set(recentMeetings.map(m => m.meeting_id));

            const meetingInfoMap = {};
            meetingList.forEach(m => {
                if (m.meeting_id) {
                    meetingInfoMap[m.meeting_id] = m.date;
                }
            });

            // 构建议员信息映射 (UID -> Name)
            // 注意：memberRes.data 可能直接是数组，也可能嵌套在 data 中
            let memberList = (Array.isArray(memberRes.data) ? memberRes.data : memberRes.data.data) || [];
            if (memberRes.data && memberRes.data.data) {
                memberList = memberRes.data.data;
            }

            console.log("Debug: First Member Item:", memberList[0]);

            const fullMemberMap = {};
            memberList.forEach(m => {
                // 根据用户提供的 API 响应，ID 字段为 uid
                const mId = m.uid || m.id || m.member_id || m._id;
                if (mId) {
                    fullMemberMap[mId] = m;
                }
            });

            // 生成用于下拉框的议员列表：去重，按姓名A-Z排序
            const uniqueMembers = Object.values(fullMemberMap);
            uniqueMembers.sort((a, b) => {
                const nameA = (a.name || "").toUpperCase();
                const nameB = (b.name || "").toUpperCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            });

            const memberOptions = uniqueMembers.map(m => ({
                value: m.uid || m.id || m.member_id || m._id,
                label: m.name
            }));

            console.log("Member Options Size:", memberOptions.length);
            console.log("Full Member Map Size:", Object.keys(fullMemberMap).length);

            if (meetingList.length > 0) {
                this.setState({
                    meetingList: meetingList,
                    // memberOptions 将在 allMeetingMemberConnections 构建后设置
                });
                if (meetingList[0] && meetingList[0].meeting_id) {
                    this.getTopics(meetingList[0].meeting_id);
                }
            }

            let graphBody = graphRes.data.data || graphRes.data || {};
            let apiNodes = graphBody.nodes || [];
            let apiLinks = graphBody.links || [];

            // 2. 处理节点：通过 meetingInfoMap 区分会议和议员
            const allNodes = apiNodes.map(node => {
                // 如果ID存在于会议列表中，则是会议节点
                const isMeeting = meetingInfoMap.hasOwnProperty(node.id);

                let label = node.id;
                let group = 'meetGroup';

                if (isMeeting) {
                    group = 'meetGroup';
                    label = meetingInfoMap[node.id] || node.name || node.id; // 优先使用日期
                } else {
                    group = 'speakerGroup';
                    // 优先使用 Full Member Map 中的名字 (从 bulk info 接口获取)
                    if (fullMemberMap[node.id]) {
                        label = fullMemberMap[node.id].name;
                    } else {
                        // 其次尝试从 attributes 中获取
                        const attrName = node.attributes && (node.attributes.name || node.attributes.Name);
                        label = attrName || node.name || node.id;
                    }
                }

                return {
                    ...node,
                    label: label,
                    group: group
                };
            });

            console.log("Meeting Info Map Size:", Object.keys(meetingInfoMap).length);

            // 3. 构建节点和边 (只保留最近的 50 个会议节点 + 200 个相关议员)
            const finalNodeArr = [];
            const edgeArr = [];
            const relatedMemberIds = new Set();
            const meetingsAdded = new Set();

            // 4. 筛选最近 N 个会议 (或者使用 overrideMeetingIds)
            let targetMeetingIds = new Set();

            if (overrideMeetingIds && overrideMeetingIds.size > 0) {
                // Search Mode: use filtered IDs
                targetMeetingIds = overrideMeetingIds;
            } else {
                // Default Mode: Recent 50
                // Default: Sort by date desc (Assuming logic above does sorting or we trust API order)
                // meetingList is sorted by date desc in fetch logic?
                // Let's assume meetingList is sorted.
                meetingList.slice(0, 50).forEach(m => targetMeetingIds.add(m.meeting_id));
            }

            // 找出所有 Meeting Nodes
            const meetingNodes = allNodes.filter(n => n.group === 'meetGroup' && targetMeetingIds.has(n.id));

            // Map: MeetingID -> Set(MemberIDs connected) - 基于所有会议构建，而不仅仅是targetMeetingIds
            // 这样搜索时才能找到所有议员参加的会议
            const meetingMemberConnections = {};
            const allMeetingIdsFromMap = new Set(Object.keys(meetingInfoMap));

            // 预处理连边，找出每个会议连接的议员 - 扫描所有会议
            apiLinks.forEach(link => {
                const sourceIsMeeting = allMeetingIdsFromMap.has(link.source);
                const targetIsMeeting = allMeetingIdsFromMap.has(link.target);

                let mId = null;
                let pId = null;

                if (sourceIsMeeting && !meetingInfoMap[link.target]) {
                    mId = link.source;
                    pId = link.target;
                } else if (targetIsMeeting && !meetingInfoMap[link.source]) {
                    mId = link.target;
                    pId = link.source;
                }

                if (mId && pId) {
                    if (!meetingMemberConnections[mId]) {
                        meetingMemberConnections[mId] = new Set();
                    }
                    meetingMemberConnections[mId].add(pId);
                }
            });
            this.allMeetingMemberConnections = meetingMemberConnections; // Persist for search and count calculation

            // 收集所有在图谱关系中存在的议员ID（基于所有会议，而不仅是当前渲染的50个）
            const allMembersInGraph = new Set();
            Object.values(meetingMemberConnections).forEach(membersSet => {
                membersSet.forEach(mId => allMembersInGraph.add(mId));
            });

            // 过滤 memberOptions，只包含在图谱关系中存在的议员
            const filteredMemberOptions = uniqueMembers
                .filter(m => {
                    const mId = m.uid || m.id || m.member_id || m._id;
                    return allMembersInGraph.has(mId);
                })
                .map(m => ({
                    value: m.uid || m.id || m.member_id || m._id,
                    label: m.name
                }));

            console.log("Filtered Member Options Size:", filteredMemberOptions.length, "(from", uniqueMembers.length, "total)");
            this.setState({ memberOptions: filteredMemberOptions });

            // 添加会议节点
            const addedIds = new Set();
            meetingNodes.forEach(node => {
                if (!addedIds.has(node.id)) {
                    finalNodeArr.push({
                        ...node,
                        label: meetingInfoMap[node.id] || node.id // Ensure date label
                    });
                    meetingsAdded.add(node.id);
                    addedIds.add(node.id);
                }
            });

            // 添加议员节点 (每个会议选 15 个，以平衡信息量与渲染性能)
            meetingNodes.forEach(mNode => {
                const members = meetingMemberConnections[mNode.id];
                if (members) {
                    let count = 0;
                    for (const pId of members) {
                        // 强制包含特定议员（搜索目标），即使超过15个
                        const isForced = (forceMemberId && pId === forceMemberId);

                        if (count >= 15 && !isForced) {
                            continue; // Skip if limit reached AND not forced
                        }
                        if (count >= 15 && isForced) {
                            // If limit reached but this is the forced member, allow it.
                            // logic flows through.
                        } else if (count >= 15) {
                            // Should have been caught by continue, but double check breaking
                            // Actually 'continue' only skips this iteration. 
                            // If we want to strictly stop adding *others* after 15, we should break.
                            // But we need to scan for forceMemberId potentially later in the list?
                            // Yes. So we simply: Only add if (count < 15 OR isForced).
                        }

                        if (count >= 15 && !isForced) continue; // Skip others if full

                        // 检查节点是否存在于原始节点列表中 (allNodes check)
                        const pNodeOrig = allNodes.find(n => n.id === pId);

                        // 增加校验：只有当数据库中存在该议员信息时，才添加到图谱中
                        if (pNodeOrig && fullMemberMap[pId]) {
                            if (!relatedMemberIds.has(pId)) {
                                relatedMemberIds.add(pId);
                                finalNodeArr.push(pNodeOrig);
                            }
                            // Reverse direction: Member -> Meeting
                            edgeArr.push({ from: pId, to: mNode.id });
                            count++;
                        }
                    }
                }
            });
            console.log(`Graph Filtered (New Logic): ${meetingNodes.length} meetings (Target 50), ${relatedMemberIds.size} members (Target ~200).`);

            // 5. 构建缓存：只保存图谱中用到的议员数据
            const usedMemberCache = {};
            relatedMemberIds.forEach(mId => {
                if (fullMemberMap[mId]) {
                    usedMemberCache[mId] = fullMemberMap[mId];
                }
            });
            this.setState({ memberCache: usedMemberCache }); // 保存到 State



            const nodes = new vis.DataSet(finalNodeArr);
            const edges = new vis.DataSet(edgeArr);

            // 用户的需求是 "在图谱上渲染"，所以只改图谱数据。

            // 用于初始选中的逻辑使用 finalNodeArr
            let nodeArr = finalNodeArr;

            // create a network知识图谱
            var container = document.getElementById('mynetwork')
            var data = {
                nodes: nodes,
                edges: edges,
            }
            const kgOptions = {
                // interaction: {
                //   hover: true
                // },
                groups: {
                    meetGroup: { color: { background: '#f6a246' }, borderWidth: 1 },
                    speakerGroup: { color: { background: '#004aad' }, borderWidth: 1 },
                },
                nodes: {
                    shape: 'dot',
                    borderWidth: 2,
                    size: 30, // Increased size
                    color: {
                        background: '#004aad',
                        highlight: { border: '#d66a05' },
                        hover: { border: '#d66a05' },
                    },
                    font: { color: '#004aad', size: 18 },
                },
                edges: {
                    arrows: { to: true },
                    color: { color: '#ccc', highlight: '#d66a05', hover: '#d66a05' },
                    font: { size: 20, color: '#333', strokeColor: 'transparent', background: '#fff' },
                    selectionWidth: 2,
                    hoverWidth: 2,
                },
                physics: {
                    enabled: true,
                    barnesHut: {
                        gravitationalConstant: -8000,
                        centralGravity: 0.5,
                        springLength: 300,
                        springConstant: 0.04,
                        damping: 0.5,
                        avoidOverlap: 1 // Enable strict avoidance to prevent overlap
                    },
                    maxVelocity: 20, // Lower velocity limit
                    minVelocity: 0.1,
                    solver: 'barnesHut',
                    timestep: 0.5,
                    adaptiveTimestep: true,
                    stabilization: {
                        enabled: true,
                        iterations: 100,
                        updateInterval: 25
                    }
                },
                layout: {
                    improvedLayout: false,
                },
                interaction: {
                    hover: true,
                    hoverConnectedEdges: true, // 鼠标悬停节点时高亮连接的边
                    selectConnectedEdges: true, // 点击节点时选中连接的边
                    dragView: true,
                    zoomView: true,
                    dragNodes: true,
                    navigationButtons: true, // Optional: adds zoom/pan buttons
                    keyboard: true // Optional: allows keyboard navigation
                },
            }
            var network = new vis.Network(container, data, kgOptions)

            this.setState({
                mapInstance: network,
            })

            // 初始化默认选中（随机一个会议）
            if (nodeArr.length > 0) {
                const meetNodes = nodeArr.filter(n => n.group === 'meetGroup');
                const lastMeet = meetNodes.length > 0
                    ? meetNodes[Math.floor(Math.random() * meetNodes.length)]
                    : nodeArr[nodeArr.length - 1];

                // 自动调整缩放以适应视口或聚焦选中节点
                network.once("stabilizationIterationsDone", function () {
                    if (lastMeet) {
                        // 用户要求“视角再拉近一点，能看清局部节点信息就可以”
                        // 使用 focus 聚焦到选中的会议节点，scale 0.6 (缩小视图) 表示60%缩放
                        network.focus(lastMeet.id, {
                            scale: 0.6,
                            animation: {
                                duration: 1000,
                                easingFunction: "easeInOutQuad",
                            }
                        });
                    } else {
                        network.fit({
                            animation: {
                                duration: 1000,
                                easingFunction: "easeInOutQuad",
                            },
                        });
                    }
                });

                if (lastMeet) {
                    // 统计该会议实际连接的议员节点数量
                    const connectedEdges = edges.get({
                        filter: function (edge) {
                            return edge.from === lastMeet.id || edge.to === lastMeet.id;
                        }
                    });

                    const uniqueMemberIds = new Set();
                    connectedEdges.forEach(edge => {
                        const otherNodeId = edge.from === lastMeet.id ? edge.to : edge.from;
                        const otherNode = nodes.get(otherNodeId);
                        if (otherNode && otherNode.group === 'speakerGroup') {
                            uniqueMemberIds.add(otherNodeId);
                        }
                    });

                    // 从 meetingList 中获取详细信息
                    const meetingInfo = this.state.meetingList.find(m => m.meeting_id === lastMeet.id) || {};

                    this.setState({
                        speakerName: meetingInfo.highlight_speaker || 'Default Speaker',
                        speakerContent: meetingInfo.highlight_content || 'No content available.',
                        selMeetDate: lastMeet.date || lastMeet.label,
                        link: meetingInfo.source_pdf_url || '',
                        num: meetingInfo.chamber || '',
                        speakerCount: (this.allMeetingMemberConnections && this.allMeetingMemberConnections[lastMeet.id]) ? this.allMeetingMemberConnections[lastMeet.id].size : 0, // 使用实际连接的议员节点数量
                        speechCount: meetingInfo.speaker_count || 0, // 使用 API 返回的发言数量
                        minorHeading: meetingInfo.topic_count || 0,
                        // visitCount: lastMeet.visitCount, // 如果没有就不设置
                        showMeeting: true,
                        graphLoaded: true, // 图谱加载完成，显示信息
                        current_meet: meetingInfo // 保存当前会议信息（包含 congress_number）
                    });
                    // 确保词云也更新（传入会议ID）
                    this.drawWordCloud(key, lastMeet.id);
                } else {
                    // 没有任何节点的情况，也算加载完成，避免一直Loading
                    this.setState({ graphLoaded: true });
                }
            } else {
                this.setState({ graphLoaded: true });
            }

            let that = this
            network.on('click', async function (params) {
                if (params.nodes.length === 0) return;
                let nodeId = params.nodes[0]
                // 从 nodes DataSet 中获取节点对象
                let clickedNode = nodes.get(nodeId);

                // 选中节点，连接的边会自动高亮（通过 selectConnectedEdges: true 配置）
                network.selectNodes([nodeId]);

                if (clickedNode.group === 'speakerGroup') {
                    // 直接从缓存获取数据
                    const memberData = that.state.memberCache[nodeId] || {};

                    // 处理近期动态 (media 字段)
                    // 注意：API 返回的 media 是 JSON 字符串，需要先解析
                    let mediaArray = [];
                    try {
                        if (typeof memberData.media === 'string') {
                            mediaArray = JSON.parse(memberData.media);
                        } else if (Array.isArray(memberData.media)) {
                            mediaArray = memberData.media;
                        }
                    } catch (e) {
                        console.error('解析 media 字段失败:', e);
                    }

                    const yiyuanList = Array.isArray(mediaArray)
                        ? mediaArray.map(item => ({
                            title: item.title || item.content || '无标题'
                        }))
                        : [];

                    // 处理参与议会 (meets 字段)
                    // 注意：API 返回的 meets 是 JSON 字符串，也可能是字符串 "NaN"
                    let meetsArray = [];
                    try {
                        if (typeof memberData.meets === 'string' && memberData.meets !== 'NaN') {
                            meetsArray = JSON.parse(memberData.meets);
                        } else if (Array.isArray(memberData.meets)) {
                            meetsArray = memberData.meets;
                        }
                    } catch (e) {
                        console.error('解析 meets 字段失败:', e);
                    }

                    const canyuyihui = Array.isArray(meetsArray)
                        ? meetsArray.map(item => ({
                            title: item.title || item.datestr || item.date || '无标题'
                        }))
                        : [];

                    // 处理头像 (photo_url 字段)
                    let personImg = ukPerson;
                    try {
                        if (memberData.photo_url) {
                            if (typeof memberData.photo_url === 'string') {
                                // 尝试判断是否为 JSON 格式（以 " 或 [ 开头）
                                if (memberData.photo_url.trim().startsWith('"') || memberData.photo_url.trim().startsWith('[')) {
                                    const parsed = JSON.parse(memberData.photo_url);
                                    personImg = Array.isArray(parsed) ? (parsed[0] || ukPerson) : parsed;
                                } else {
                                    // 普通字符串直接使用
                                    personImg = memberData.photo_url;
                                }
                            } else {
                                personImg = memberData.photo_url;
                            }
                        }
                    } catch (e) {
                        console.error('解析 photo_url 字段失败:', e);
                        // 出错时尝试直接使用
                        personImg = memberData.photo_url || ukPerson;
                    }

                    that.setState({
                        personImg: personImg,
                        yiyuanName: memberData.name || clickedNode.label,
                        yiyuanParty: memberData.party,
                        yiyuanArea: memberData.state || memberData.area,
                        yiyuanTwi: memberData.xurl,          // Twitter 链接使用 xurl 字段
                        yiyuanFace: memberData.website,      // Facebook 链接使用 website 字段
                        served: memberData.served || memberData.terms, // 适配字段 served
                        birthday: memberData.birthdate || memberData.birthday, // 适配字段 birthdate
                        showMeeting: false, // 切换到议员显示模式
                        canyuyihui: canyuyihui, // 从 memberData.meets 获取参与议会数据
                        yiyuanList: yiyuanList  // 从 memberData.media 获取近期动态数据
                    })

                    // 直接从 memberData 解析重点关注数据 (focus 字段)
                    let focusData = [];
                    try {
                        if (typeof memberData.focus === 'string') {
                            focusData = JSON.parse(memberData.focus);
                        } else if (Array.isArray(memberData.focus)) {
                            focusData = memberData.focus;
                        }
                    } catch (e) {
                        console.error('解析 focus 字段失败:', e);
                    }
                    that.updateFocusChart(focusData);

                } else if (clickedNode.group === 'meetGroup') {
                    // 会议节点点击逻辑
                    // 1. 设置选中日期
                    const selectedDate = clickedNode.label; // Label is date

                    // 2. 查找会议详细信息 (from meetingList)
                    const meetingInfo = that.state.meetingList.find(m => m.meeting_id === nodeId) || {};

                    // 3. 统计该会议实际连接的议员节点数量
                    // 通过 edges 数据集查找与该会议节点相连的所有边
                    const connectedEdges = edges.get({
                        filter: function (edge) {
                            return edge.from === nodeId || edge.to === nodeId;
                        }
                    });

                    // 统计唯一的议员节点（排除会议节点自身）
                    const uniqueMemberIds = new Set();
                    connectedEdges.forEach(edge => {
                        const otherNodeId = edge.from === nodeId ? edge.to : edge.from;
                        // 确保是议员节点（通过检查节点类型）
                        const otherNode = nodes.get(otherNodeId);
                        if (otherNode && otherNode.group === 'speakerGroup') {
                            uniqueMemberIds.add(otherNodeId);
                        }
                    });
                    const actualMemberCount = uniqueMemberIds.size;

                    that.setState({
                        selMeetDate: selectedDate,
                        link: meetingInfo.source_pdf_url || '', // Use source_pdf_url from meetingList
                        num: meetingInfo.chamber || '', // Use chamber from meetingList
                        speakerCount: (that.allMeetingMemberConnections && that.allMeetingMemberConnections[nodeId]) ? that.allMeetingMemberConnections[nodeId].size : 0, // 使用实际连接的议员节点数量
                        speechCount: meetingInfo.speaker_count || 0, // 发言数量移到这里
                        minorHeading: meetingInfo.topic_count || 0, // Use topic_count from meetingList
                        showMeeting: true,
                        speakerName: meetingInfo.highlight_speaker || 'Unknown',
                        speakerContent: meetingInfo.highlight_content || 'No content available.',
                        current_meet: meetingInfo // 保存当前会议信息（包含 congress_number）
                    });

                    // 3. 加载 Word Cloud
                    that.drawWordCloud(key, nodeId);

                    // 4. 加载 Topics
                    that.getTopics(nodeId);

                }
            })
        } catch (error) {
            console.error("Error loading graph data:", error);
        }
    }
    drawGenderPie() {
        const genderOption = {
            tooltip: {
                trigger: 'item',
                formatter: '{b}\n{d}%',
            },
            color: ['#4874cb', '#ee822f'],
            series: [
                {
                    name: '性别比例',
                    type: 'pie',
                    radius: '65%',
                    data: [
                        { value: 65, name: '男性' },
                        { value: 35, name: '女性' },
                    ],
                    label: {
                        formatter: '{b}\n{d}%',
                        lineHeight: 18,
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                    },
                },
            ],
        }
        this.setState({
            genderOption: genderOption,
        })
    }
    // drawRose(key) {
    //     const partyOption = {
    //         legend: {
    //             top: 'top',
    //         },
    //         tooltip: {
    //             trigger: 'item',
    //             formatter: '{b}\n{c}',
    //         },
    //         series: [
    //             {
    //                 name: 'Party Status',
    //                 type: 'pie',
    //                 radius: [30, 99],
    //                 center: ['50%', '60%'],
    //                 roseType: 'area',
    //                 itemStyle: {
    //                     borderRadius: 8,
    //                 },
    //                 label: {
    //                     position: 'outside',
    //                 },
    //                 labelLine: {
    //                     show: true,
    //                     length: -10,
    //                 },
    //                 emphasis: {
    //                     itemStyle: {
    //                         shadowBlur: 10,
    //                         shadowOffsetX: 0,
    //                         shadowColor: 'rgba(0, 0, 0, 0.5)',
    //                     },
    //                 },
    //                 data: mockdata[key].partyDatas
    //             },
    //         ],
    //     }
    //     this.setState({
    //         partyOption: partyOption,
    //     })
    // }
    // async drawRader(country, id) {
    //     const radar_res = await fetch({
    //         url: '/graph/focus/search?country=' + country + '&member=' + id,
    //         method: "get",
    //     })
    //     const areaOption = {
    //         legend: {
    //             data: ['议员平均关注程度', '该议员关注程度'],
    //             bottom: 'bottom',
    //         },
    //         // tooltip: {
    //         //     trigger: 'item',
    //         // },
    //         tooltip: {
    //             trigger: 'item',
    //             formatter: function (params) {
    //                 let result = '';
    //                 params.value.forEach(function (value, i) {
    //                     // 使用雷达图的完整名称
    //                     let fullName = areaOption.radar.indicator[i].name;
    //                     result += fullName + ' : ' + value + '<br/>';
    //                 });
    //                 return result;
    //             }
    //         },
    //         radar: {
    //             // shape: 'circle',
    //             center: ['50%', '40%'],
    //             radius: '50%',
    //             indicator: radar_res.data.data.indicator,
    //             name: {
    //                 formatter: function (name) {
    //                     return name.length > 6 ? name.slice(0, 6) + '...' : name;
    //                 }
    //             }
    //         },
    //         series: [
    //             {
    //                 name: '关注领域',
    //                 type: 'radar',
    //                 data: [
    //                     {
    //                         value: radar_res.data.data.avg,
    //                         name: '议员平均关注程度',
    //                     },
    //                     {
    //                         value: radar_res.data.data.self,
    //                         name: '该议员关注程度',
    //                     },
    //                 ],

    //             },
    //         ],
    //     }
    //     this.setState({
    //         areaOption: areaOption,
    //     })
    // }

    updateFocusChart(focusData) {
        // focusData format: [{"Topic": "Score"}, {"Topic": "Score"}, ...]
        // We need to transform this into {name: "Topic", value: Number(Score)}

        const list = Array.isArray(focusData) ? focusData : [];
        const pieData = [];

        list.forEach(item => {
            // item is like {"Congress": "188"} or {"Show more": ""}
            for (let key in item) {
                if (key === 'Show more' || !item[key]) continue;
                const val = parseInt(item[key], 10);
                if (!isNaN(val) && val > 0) {
                    pieData.push({
                        name: key,
                        value: val
                    });
                }
            }
        });

        // Sort by value desc and take top N? Or just show all? 
        // Pie charts get messy with too many slices. Let's limit to top 15 if needed, but user didn't specify.
        // For now, use all valid data.
        pieData.sort((a, b) => b.value - a.value);
        const top7Data = pieData.slice(0, 7);

        const pieOption = {
            title: {
                // text: '议员关注程度分布',
                left: 'center',
                top: 'top',
                textStyle: {
                    fontSize: 16,
                    fontWeight: 'bold'
                }
            },
            tooltip: {
                trigger: 'item',
                formatter: function (params) {
                    // 饼图的tooltip格式化
                    return `${params.name}<br/>${params.seriesName}: ${params.value} (${params.percent}%)`;
                }
            },
            series: [
                {
                    name: '关注程度',
                    type: 'pie',
                    radius: ['40%', '70%'], // 环形饼图，内半径40%，外半径70%
                    center: ['50%', '50%'], // 饼图位置，左35%，垂直居中
                    avoidLabelOverlap: true, // 避免标签重叠
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    label: {
                        show: true,
                        formatter: function (params) {
                            // 标签显示格式：名称 + 百分比
                            return `${params.name}: ${params.percent}%`;
                        },
                        textStyle: {
                            fontSize: 10
                        }
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: 12,
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: true,
                        length: 10,
                        length2: 10
                    },
                    data: top7Data
                }
            ]
        };

        this.setState({
            areaOption: pieOption, // 更新为饼图配置
        });
    }

    componentDidMount() {
        // let maskImage = new Image();
        // // 此为词云图呈现形状的图片base64码，可选，可以自定义图片
        // maskImage.src =
        //   "data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjI1NnB4IiBoZWlnaHQ9IjI1NnB4IiB2aWV3Qm94PSIwIDAgNTQ4LjE3NiA1NDguMTc2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1NDguMTc2IDU0OC4xNzY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8cGF0aCBkPSJNNTI0LjE4MywyOTcuMDY1Yy0xNS45ODUtMTkuODkzLTM2LjI2NS0zMi42OTEtNjAuODE1LTM4LjM5OWM3LjgxLTExLjk5MywxMS43MDQtMjUuMTI2LDExLjcwNC0zOS4zOTkgICBjMC0yMC4xNzctNy4xMzktMzcuNDAxLTIxLjQwOS01MS42NzhjLTE0LjI3My0xNC4yNzItMzEuNDk4LTIxLjQxMS01MS42NzUtMjEuNDExYy0xOC4yNzEsMC0zNC4wNzEsNS45MDEtNDcuMzksMTcuNzAzICAgYy0xMS4yMjUtMjcuMDI4LTI5LjA3NS00OC45MTctNTMuNTI5LTY1LjY2N2MtMjQuNDYtMTYuNzQ2LTUxLjcyOC0yNS4xMjUtODEuODAyLTI1LjEyNWMtNDAuMzQ5LDAtNzQuODAyLDE0LjI3OS0xMDMuMzUzLDQyLjgzICAgYy0yOC41NTMsMjguNTQ0LTQyLjgyNSw2Mi45OTktNDIuODI1LDEwMy4zNTFjMCwyLjg1NiwwLjE5MSw2Ljk0NSwwLjU3MSwxMi4yNzVjLTIyLjA3OCwxMC4yNzktMzkuODc2LDI1LjgzOC01My4zODksNDYuNjg2ICAgQzYuNzU5LDI5OS4wNjcsMCwzMjIuMDU1LDAsMzQ3LjE4YzAsMzUuMjExLDEyLjUxNyw2NS4zMzMsMzcuNTQ0LDkwLjM1OWMyNS4wMjgsMjUuMDMzLDU1LjE1LDM3LjU0OCw5MC4zNjIsMzcuNTQ4aDMxMC42MzYgICBjMzAuMjU5LDAsNTYuMDk2LTEwLjcxNSw3Ny41MTItMzIuMTIxYzIxLjQxMy0yMS40MTIsMzIuMTIxLTQ3LjI0OSwzMi4xMjEtNzcuNTE1ICAgQzU0OC4xNzIsMzM5Ljc1Nyw1NDAuMTc0LDMxNi45NTIsNTI0LjE4MywyOTcuMDY1eiIgZmlsbD0iI0ZGRkZGRiIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";

        this.drawWordCloud(this.state.defaultCountry)

        this.drawGraphData(this.state.defaultCountry)

        //雷达图
        // this.drawRader(this.state.defaultCountry, "1")
        //词云
        if (this.ciyun.current && !this.leftHeight && !this.leftWidth) {
            this.setState({
                leftHeight: this.ciyun.current.offsetHeight,
                leftWidth: this.ciyun.current.offsetWidth
            })
        }
        //避免重复添加监听事件
        if (this.state.listenerFlag === false) {
            document.addEventListener("itemInserted", this.localStorageSetHandler.bind(this), false);
            this.setState({
                listenerFlag: true
            })
        }
    }

    handleDateSearch = (date, dateString) => {
        if (!dateString) {
            // 清除日期：恢复默认视图
            console.log("Date search cleared. Restoring default view.");
            this.drawGraphData(this.state.defaultCountry);
            message.info('已恢复默认图谱视图');
            return;
        }

        // Find meeting node: meetingList has date string 'YYYY-MM-DD'
        const meeting = this.state.meetingList.find(m => m.date === dateString);

        if (meeting) {
            // 搜索模式：只显示该会议及其关联的所有议员节点
            const meetingId = meeting.meeting_id;
            const overrideMeetingIds = new Set([meetingId]);

            console.log(`Search: Meeting ${meetingId} on ${dateString}`);
            // 重新渲染图谱，传入过滤后的会议ID集合
            this.drawGraphData(this.state.defaultCountry, overrideMeetingIds, null);
            message.success(`已过滤显示 ${dateString} 的会议及其关联议员`);
        } else {
            message.warning(`No meeting found for date ${dateString}`);
        }
    }

    handleMemberSearch = (value) => {
        // Value is the ID directly or undefined/null if cleared
        const memberId = value;

        if (memberId) {
            // 搜索模式：只显示该议员及其相关的会议节点
            // 1. 找出该议员参加的所有会议
            const relatedMeetingIds = new Set();

            // 遍历所有会议连接关系
            if (this.allMeetingMemberConnections) {
                Object.entries(this.allMeetingMemberConnections).forEach(([meetId, membersSet]) => {
                    if (membersSet.has(memberId)) {
                        relatedMeetingIds.add(meetId);
                    }
                });
            }

            if (relatedMeetingIds.size > 0) {
                console.log(`Search: Member ${memberId} found in ${relatedMeetingIds.size} meetings.`);
                // 重新渲染图谱，传入过滤后的会议ID集合以及强制包含的议员ID
                this.drawGraphData(this.state.defaultCountry, relatedMeetingIds, memberId);
                message.success(`已过滤显示该议员相关的 ${relatedMeetingIds.size} 个会议`);
            } else {
                message.warning('该议员在当前数据集中未找到相关会议记录');
            }

        } else {
            // 取消搜索：恢复默认视图
            console.log("Search cleared. Restoring default view.");
            this.drawGraphData(this.state.defaultCountry);
            message.info('已恢复默认图谱视图');
        }
    }

    render() {
        const mapName = {
            "us": "美国",
            "uk": "英国",
            "ru": "俄罗斯",
            "eu": "欧洲",
            "fr": "法国",
            "ge": "德国",
            "ca": "加拿大",
            "pk": "巴基斯坦",
            "my": "马来西亚",
            "sg": "新加坡",
            "tr": "土耳其",
            "nz": "新西兰",
            "india": "印度",
            "pl": "波兰",
            "za": "南非",
            "at": "奥地利"
        }

        return (
            <div className="graph-container">
                <div style={{ display: 'flex', gap: '16px', height: '100%' }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '16px',
                            flex: '0 0 22%', // Fixed width 22%
                            minWidth: 0, // Prevent flex item overflow
                        }}
                    >

                        {/* 控制显示议会还是议员内容*/}
                        <div style={{ flex: 1, overflow: 'hidden' }} ref={this.ciyun}>
                            {!this.state.graphLoaded ? (
                                <div className="g-card" style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Skeleton active />
                                </div>
                            ) : this.state.showMeeting ? (
                                <div className="g-card" style={{ height: '100%' }}>
                                    <div className="panelTitle">
                                        <SoundOutlined /> 议会情况
                                    </div>
                                    <div
                                        className="panelContent"
                                        style={{ fontSize: 22, flexDirection: 'column' }}
                                    >
                                        <div
                                            style={{
                                                textAlign: 'center',
                                                fontSize: 18,
                                                fontWeight: 500,
                                            }}
                                        >
                                            <p >
                                                <span style={{ fontSize: 16 }}>议会时间：</span>
                                                <span
                                                    style={{
                                                        color: '#6300bf',
                                                        fontSize: 20,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    <a target="_blank" href={this.state.link} className='meetDate'>{this.state.selMeetDate}</a>
                                                </span>
                                            </p>
                                            <p style={{ fontSize: 16 }}>
                                                （当年第
                                                <span
                                                    style={{
                                                        color: '#027db4',
                                                        fontSize: 20,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    &nbsp;{this.state.current_meet ? this.state.current_meet.congress_number : '--'} &nbsp;
                                                </span>
                                                次议会）
                                            </p>
                                        </div>
                                        <div
                                            style={{ display: 'flex', justifyContent: 'space-evenly' }}
                                        >
                                            <div>
                                                <p style={{ color: '#b5b5ff' }}>{this.state.speakerCount}</p>
                                                <p style={{ fontSize: 16 }}>议员</p>
                                            </div>
                                            <div>
                                                <p style={{ color: '#ec808d' }}>{this.state.speechCount}</p>
                                                <p style={{ fontSize: 16 }}>发言</p>
                                            </div>
                                            <div>
                                                <p style={{ color: '#70b603' }}>{this.state.minorHeading}</p>
                                                <p style={{ fontSize: 16 }}>议题</p>
                                            </div>
                                            {/* <div>
                                                <p style={{ color: '#f59a23' }}>{this.state.visitCount}</p>
                                                <p style={{ fontSize: 16 }}>访问记录</p>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="panelTitle" style={{ marginTop: 30 }}>
                                        <SoundOutlined /> 议题词云
                                    </div>
                                    <div
                                        className="panelContent"
                                        style={{ flex: 1 }}
                                    // ref={this.ciyun}
                                    >
                                        <ReactEcharts
                                            option={this.state.cloudOption}
                                            notMerge={true}  // 强制不合并，完全重新渲染
                                            lazyUpdate={false}  // 立即更新
                                            theme="ThemeStyle"
                                            style={{
                                                height: 460,
                                                width: '95%'
                                            }}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="g-card" style={{ height: '100%' }}>
                                    <div className="panelTitle">
                                        <SoundOutlined /> 议员情况
                                    </div>
                                    <div className="panelContent" style={{ fontSize: 16 }}>
                                        <div style={{ display: 'flex' }}>
                                            {/* 原来这里的议员头像图片是固定宽度160 */}
                                            <div style={{ width: '45%' }}><img src={this.state.personImg} alt="Avatar" style={{ width: '100%', height: 200 }} /></div>
                                            <div style={{ marginLeft: 10, flex: 1 }}>
                                                <div><span className='formTitle'>议员(Member)</span>: <span className='formValue' title={this.state.yiyuanName}>&nbsp;&nbsp;{this.state.yiyuanName}</span></div>
                                                <div><span className='formTitle'>党派(Faction)</span>: <span className='formValue' title={this.state.yiyuanParty}>&nbsp;&nbsp;{this.state.yiyuanParty}</span></div>
                                                <div><span className='formTitle'>地区(Region)</span>:<span className='formValue' title={this.state.yiyuanArea}>&nbsp;&nbsp;{this.state.yiyuanArea}</span></div>
                                                <div><span className='formTitle'>出生日期(Birthdate)</span>:<span className='formValue' title={this.state.birthday}>{this.state.birthday}</span></div>
                                            </div>
                                        </div>
                                        <div style={{ marginTop: 5, paddingLeft: 6 }}><span className='formTitle'>任期(Served)</span>:<span className='formLongValue'>&nbsp;&nbsp;{this.state.served}</span></div>

                                        <div style={{ marginTop: 5, display: 'flex', alignItems: 'center' }}><img className='logo' alt="Twitter" style={{ width: 18 }} src={twitterImg} />{this.state.yiyuanTwi}</div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}><img className='logo' alt="Facebook" style={{ width: 18 }} src={facebookImg} />
                                            <a target="_blank" rel="noopener noreferrer" href={this.state.yiyuanFace} title={this.state.yiyuanFace} className='formValueUrl'>&nbsp;{this.state.yiyuanFace}</a></div>
                                    </div>
                                    <div className="panelTitle" style={{ marginTop: 15 }}>
                                        <SoundOutlined /> 近期动态
                                    </div>
                                    <div className="panelContent" style={{ height: 260, overflowY: 'auto', scrollbarWidth: 'none', paddingLeft: 18 }}>
                                        <ul style={{ fontSize: 16 }}>
                                            {this.state.yiyuanList.map((item, index) => {
                                                return (
                                                    <li key={index}>{item.title}</li>
                                                )
                                            })}
                                        </ul>
                                    </div>

                                </div>
                            )}
                        </div>
                        {/* 议员时显示 end*/}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '16px',
                            flex: '0 0 54%', // Fixed width 54% (leaving slight gap for margins)
                            minWidth: 0,
                        }}
                    >
                        <div
                            className="g-card"
                            style={{
                                height: '100%',
                                border: 'none',
                                backgroundColor: '#f5f7fa',
                            }}
                            ref={this.tupu}
                        >
                            <div className="panelTitle" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <SoundOutlined style={{ marginRight: 8 }} />
                                    <span style={{ color: '#eb4b0b', marginRight: 4 }}>{mapName[this.state.title]}</span>
                                    议会/议员关联图谱
                                </div>
                                <div style={{ display: 'flex', gap: '12px', paddingRight: '15px', alignItems: 'center' }}>
                                    <DatePicker onChange={this.handleDateSearch} placeholder="日期查找议会" style={{ width: 160 }} allowClear />
                                    <Select
                                        placeholder="选择议员"
                                        onChange={this.handleMemberSearch}
                                        options={this.state.memberOptions || []}
                                        style={{ width: 220 }}
                                        allowClear
                                    />
                                </div>
                            </div>
                            <div className="panelContent" style={{ flex: 1 }}>
                                <div
                                    id="mynetwork"
                                    style={{
                                        // height: 690,
                                        height: 690,
                                        width: '100%',
                                    }}
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div style={{
                        flex: '0 0 22%', // Fixed width 22%
                        minWidth: 0,
                    }}>
                        {!this.state.graphLoaded ? (
                            <div className='g-card' style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Skeleton active />
                            </div>
                        ) : this.state.showMeeting ? (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '16px',
                                    height: '100%'
                                }}
                            >

                                <div className="g-card" style={{ flex: 1 }}>
                                    <div className="panelTitle">
                                        <SoundOutlined /> 议会主题
                                    </div>
                                    <div className='panelContent'>
                                        <div style={{ height: 210, overflowY: 'auto', scrollbarWidth: 'none', paddingLeft: 18, fontSize: 16 }}>
                                            <ul>
                                                {this.state.topicList.map((item, index) => {
                                                    return (
                                                        <li key={index}>{item.title}</li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="panelTitle" style={{ marginTop: 5, marginBottom: 5 }}>
                                        <SoundOutlined /> 精彩发言
                                    </div>
                                    <div className="panelContent" style={{ flex: 1 }}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '8px',
                                            }}
                                        >
                                            <div style={{ padding: 2 }}>
                                                <img alt="" className="meeting-img" src={this.state.meetingImg} />
                                            </div>
                                            <div
                                                style={{
                                                    textAlign: 'center',
                                                    fontSize: 18,
                                                    fontWeight: 500,
                                                }}
                                            >
                                                {this.state.speakerName}
                                            </div>
                                            <div style={{ height: 142, overflowY: 'auto', scrollbarWidth: 'none', textIndent: '1em', fontSize: 16, marginBottom: 18 }}>
                                                {this.state.speakerContent}
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div style={{ padding: 2 }}>
                                        <img alt="" className="meeting-img" src={meetingImg} />
                                    </div>
                                    <div
                                        style={{
                                            textAlign: 'center',
                                            fontSize: 18,
                                            fontWeight: 500,
                                        }}
                                    >
                                        {this.state.speakerName}
                                    </div>
                                    <div className="panelContent" style={{ flex: 1 }}>

                                        <div style={{ height: 130, overflowY: 'auto', scrollbarWidth: 'none', textIndent: '1em', fontSize: 16, marginBottom: 10 }}>
                                            {this.state.speakerContent}
                                        </div>

                                    </div> */}

                                </div>
                            </div>
                        ) : (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '16px',
                                    height: '100%'
                                }}
                            >
                                <div className="g-card" style={{ height: '100%' }}>
                                    <div className="panelTitle">
                                        <SoundOutlined /> 参与议会
                                    </div>
                                    <div className='panelContent' style={{ height: 304, overflowY: 'auto', scrollbarWidth: 'none', paddingLeft: 20 }}>
                                        <ul style={{ fontSize: 16 }}>
                                            {this.state.canyuyihui.map((item, index) => {
                                                return (
                                                    <li key={index}>{item.title}</li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                    <div className="panelTitle" style={{ marginTop: 16 }}>
                                        <SoundOutlined /> 重点关注
                                    </div>
                                    <div
                                        className="panelContent"
                                        style={{ flex: 1, display: 'flex' }}
                                        ref={this.area}
                                    >
                                        <ReactEcharts
                                            option={this.state.areaOption}
                                            theme="ThemeStyle"
                                            style={{
                                                height: 300,
                                                width: '93%',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default Tool
